import { Component, HostBinding } from '@angular/core'
import { Router } from '@angular/router'
import { AuthManager } from 'src/app/shared/auth/AuthManager'
import { ApplicationArea, ProductsClient } from 'src/app/shared/services/ppv.api'

@Component({
   selector: 'vc-products-landing',
   templateUrl: './products-landing.component.html',
   styleUrls: ['./products-landing.component.scss'],
   standalone: false,
})
export class ProductsLandingComponent {
   @HostBinding('class.full-flex-height') fullFlexHeight = true

   public canAccessProducts = false

   constructor(private authMgr: AuthManager, private router: Router) {
      this.authMgr.getCurrentUser().subscribe((user) => {
         this.canAccessProducts = this.authMgr.canAccess(user, {
            application: ApplicationArea.Products,
            roleName: ['VCProduct'],
         })

         if (!this.canAccessProducts) {
            this.router.navigate(['products', 'hospital'])
         }
      })
   }
}
